module.exports = __webpack_public_path__ + "static/img/banner3.d66aaeb2.png";